<template>
	<div class="hit-container">
		<h1 class="hit-html-h1">{{ $t('message.contact') }}</h1>

			<div class="hit-form-group" v-html="contact" />

	</div>
</template>
<script>

import de from 'raw-loader!@shared/language/contact/de_DE.txt'

var contact = {
  'de': ''
}

contact.de = de

export default {

  name: 'contact',
  data () {
    var lang = this.$route.params.lang

    if (typeof contact[lang] !== 'string') { lang = 'de' }

    return {
      contact: this.$nl2br(contact[lang])
    }
  }

}
</script>

<style scoped>

</style>
